<td class="publishing-table__td publishing-table__td--checkbox">
  <mat-checkbox
    color="primary"
    [checked]="selected"
    [disabled]="selectionDisabled"
    (change)="onCheckboxChange($event.checked)"
    [attr.aria-label]="'Select publication ' + displayTitle"
  ></mat-checkbox>
</td>

<td class="publishing-table__td publishing-table__td--preview">
  <div class="event-card__thumbnail">
    <div class="event-card__thumbnail-img">
      <img
        [src]="event.thumbnail"
        [alt]="displayTitle"
        loading="lazy"
        (error)="onThumbnailError($event)"
      />
    </div>
    @if (event.external_url) {
      <div class="event-card__card-overlay">
        <section>
          <a
            [href]="event.external_url"
            target="_blank"
            rel="noopener"
            class="event-card__overlay-btn"
            data-title="Open"
            [attr.aria-label]="'Open on ' + platformMeta.label"
          >
            <span class="event-card__overlay-btn-icon" [inlineSVG]="overlayIconPath"></span>
          </a>
          <button
            type="button"
            class="event-card__overlay-btn"
            data-title="Copy link"
            [copy-clipboard]="event.external_url"
            (copied)="onPublicationLinkCopied()"
            aria-label="Copy publication link"
          >
            <span class="event-card__overlay-btn-icon" [inlineSVG]="copyLinkIconPath"></span>
          </button>
        </section>
      </div>
    }
  </div>
</td>

<td class="publishing-table__td publishing-table__td--title" [attr.aria-label]="displayTitle">
  <h3 class="event-card__title">{{ displayTitle }}</h3>
</td>

<td class="publishing-table__td publishing-table__td--platform">
  @if (showPlatformIcon) {
    <span class="event-card__platform" [ngClass]="platformMeta.cssClass">
      <span class="event-card__platform-icon-wrap" [ngClass]="platformMeta.cssClass">
        <div [inlineSVG]="'/assets/publishing-status/' + platformMeta.icon" class="event-card__platform-icon"></div>
      </span>
      {{ displayPlatform }}
    </span>
  } @else {
    <span class="event-card__placeholder">{{ displayPlatform }}</span>
  }
</td>

<td class="publishing-table__td publishing-table__td--destination">
  <span class="event-card__account" [class.event-card__placeholder]="destinationIsPlaceholder">{{ displayDestination }}</span>
</td>

<td class="publishing-table__td publishing-table__td--date">
  <span class="event-card__datetime">{{ formattedDateTime }}</span>
</td>

<td class="publishing-table__td publishing-table__td--status">
  <div class="event-card__status-cell">
    <span class="event-card__badge status-cell" [ngClass]="statusMeta.cssClass">
      <i [inlineSVG]="statusMeta.icon" class="event-card__status-icon"></i>
      <span>{{ statusMeta.label }}</span>
    </span>
    @if (showStatusMessage) {
      <p class="event-card__error">{{ event.errorMessage }}</p>
    }
  </div>
</td>

<td class="publishing-table__td publishing-table__td--actions">
  <div class="publishing-table__actions-cell">
    @if (isDraft) {
      <button
        type="button"
        class="publishing-table__edit-btn"
        title="Edit"
        aria-label="Edit"
        (click)="onEditClick()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
            fill="currentColor"
          />
        </svg>
      </button>
    } @else {
      <button
        type="button"
        class="publishing-table__edit-btn"
        title="Re-edit"
        aria-label="Re-edit"
        [disabled]="isReEditing"
        (click)="onReEditClick()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
            fill="currentColor"
          />
        </svg>
      </button>
    }
    @if (event.media_id != null) {
      <button
        type="button"
        class="publishing-table__edit-btn publishing-table__edit-btn--mam"
        title="Open in MAM"
        aria-label="Open in MAM"
        (click)="onEditInMamClick()"
      >
        <span
          class="publishing-table__mam-icon"
          [inlineSVG]="mediaIconPath"
          aria-hidden="true"
        ></span>
      </button>
    }
    @if (canCancel) {
      <button
        type="button"
        class="publishing-table__edit-btn publishing-table__edit-btn--cancel"
        title="Cancel"
        aria-label="Cancel publication"
        [disabled]="isCancelling"
        (click)="onCancelClick()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
            fill="currentColor"
          />
        </svg>
      </button>
    }
  </div>
</td>
